module.exports = __webpack_public_path__ + "static/media/wasek-portfolio-single-page-service.75aa8b05.jpg";